import { render } from "./ComingSoonBadge.vue?vue&type=template&id=2ea143ee&scoped=true"
import script from "./ComingSoonBadge.vue?vue&type=script&lang=ts"
export * from "./ComingSoonBadge.vue?vue&type=script&lang=ts"

import "./ComingSoonBadge.vue?vue&type=style&index=0&id=2ea143ee&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2ea143ee"

export default script